module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/highEfficiency.8d7ec892.jpg";